export enum Core {
  LIBRARY_LOG_TAG = '[FLUID]',
  KEY_PREFIX = 'nj',
  DATA_API_KEY = '.data-api'
}
